if (!customElements.get('woola-colour-gallery')) {
  customElements.define('woola-colour-gallery', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-woola-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-woola-thumb]')];
      this.dialog = this.querySelector('dialog');
      try { this.urls = JSON.parse(this.querySelector('[data-woola-image-urls]')?.textContent || '[]'); }
      catch { this.urls = []; }
      this.querySelectorAll('[data-woola-thumb]').forEach((button) => {
        button.addEventListener('click', () => this.select(Number(button.dataset.woolaThumb)));
      });
      this.slides.forEach((slide, index) => slide.addEventListener('click', () => this.open(index)));
      this.querySelector('.woola-colour-gallery__close')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.select(0);
    }
    select(index) {
      if (!this.slides[index]) return;
      this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
      this.thumbs.forEach((thumb, n) => {
        thumb.classList.toggle('is-active', n === index);
        thumb.setAttribute('aria-pressed', String(n === index));
      });
    }
    open(index) {
      if (!this.dialog || !this.urls[index] || !this.dialog.showModal) return;
      const image = this.dialog.querySelector('img');
      if (image) image.src = this.urls[index];
      this.dialog.showModal();
    }
  });
}
